import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';

/**
 * ModelViewer component
 */
export default class Devices extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Devices',
    refs: ['hotspotWrapper', 'image[]', 'line[]', 'hotspot', 'deviceWrapper'],
  };

  /**
   *
   */
  mounted() {
    this.tl = gsap.timeline({
      paused: true,
      onStart: () => {
        this.$refs.deviceWrapper.classList.add('floating-element');
      },
    });

    if (this.$refs.hotspotWrapper) {
      this.tl.set(this.$refs.hotspotWrapper, { opacity: 1 });
    }

    if (this.$refs.hotspot) {
      this.tl.from(this.$refs.hotspot, {
        scale: 0,
        rotate: -180,
        ease: 'bounce.out',
      });
    }

    if (this.$refs.line.length > 0) {
      this.tl.set(this.$refs.line, { transformOrigin: 'right' });

      this.tl.from(this.$refs.line, {
        clipPath: 'inset(0 0 0 100%)',
        ease: 'power4.out',
        stagger: 0.04,
        duration: 0.5,
      });
    }

    if (this.$refs.image.length > 0) {
      this.tl.from(this.$refs.image, {
        scale: 0,
        transformOrigin: 'center',
        ease: 'power4.out',
        stagger: 0.04,
        duration: 0.5,
      });
    }
  }

  /**
   *
   */
  showHotspot() {
    this.tl.play();
  }

  /**
   *
   */
  hideHotspot() {
    this.tl.tweenTo(0);
  }
}
